import { event } from "../core/EventUtil";
import { KeyCode } from "../io/KeyCode";

declare global {
    interface JsideaPlugins {
        link: LinkSupport;
    }
}

export class LinkSupport {
    constructor() {
        event.on({
            type: "keydown",
            scope: document,
            passive: false,
            selector: ".jsidea-link-support",
            listener: (e) => {
                if (
                    e.event.repeat ||
                    !KeyCode.is(e.event, KeyCode.ENTER, KeyCode.SPACE)
                ) {
                    return;
                }

                e.event.preventDefault();

                e.target.dispatchEvent(
                    new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: true,
                        ctrlKey: e.event.ctrlKey,
                        shiftKey: e.event.shiftKey,
                        metaKey: e.event.metaKey,
                        altKey: e.event.altKey,
                    }),
                );
            },
        });

        event.on({
            type: "click",
            scope: document,
            selector: ".jsidea-link-support",
            listener: (e) => {
                const target = e.target as HTMLElement;
                const href = target.getAttribute("data-href");
                const targetAttr = e.event.ctrlKey
                    ? "_blank"
                    : target.getAttribute("data-target") || "_self";
                const rel = target.getAttribute("data-rel") || "";

                if (href) {
                    window.open(href, targetAttr, rel);
                } else {
                    console.warn("LinkSupport: Missing href attribute");
                }
            },
        });
    }
}
